import { KBApi, RulesetApi } from "@kdmanalytics/brm-knowledgebase";
import BrmApiClient from "services/brm/BrmApiClient";

export const kbApi = new KBApi(BrmApiClient.instance);
export const rulesetApi = new RulesetApi(BrmApiClient.instance);
